import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './ActiveCallsList.module.css';
import HeaderBar from '../HeaderBar/HeaderBar';

const ActiveCallsList = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(true);

  const agentId = state?.agentId;

  const formatDuration = (startTimestamp) => {
    if (!startTimestamp) return '0:00';
    const seconds = Math.floor((Date.now() - startTimestamp) / 1000);
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  // Bahar nikala hua taaki empty state ka "Refresh" button bhi ise chala sake.
  const fetchActiveCalls = async () => {
    setLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:2512/api';
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${baseUrl}/agent/live-monitoring/active-calls`,
        {
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      if (!res.ok) return;
      const data = await res.json();
      setCalls(data.calls || []);
    } catch (err) {
      console.error('[ActiveCallsList] Error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveCalls();
  }, []);

  const hasCalls = calls.length > 0;

  return (
    <div className={styles.page}>
      {/* Integrations page jaisa — sticky purple HeaderBar, full width.
          Back pehle jaisa /fast-agent-detail. */}
      <div className={styles.Forsticky}>
        <HeaderBar
          title="Live Monitoring"
          backTo="/fast-agent-detail"
          backgroundColor="#6524EB"
          color="#fff"
        />
      </div>

      <div className={styles.container}>
        {/* Status chip — live calls hon to hara pulsing dot, warna gray. */}
        <div className={styles.statusRow}>
          <span className={`${styles.statusChip} ${hasCalls ? styles.statusChipLive : ''}`}>
            <span className={`${styles.statusDot} ${hasCalls ? styles.statusDotLive : ''}`} />
            {loading
              ? 'Checking…'
              : `${calls.length} active call${calls.length !== 1 ? 's' : ''}`}
          </span>
        </div>

        {/* Loading — skeleton cards */}
        {loading && (
          <div className={styles.skeletonList} aria-label="Loading active calls">
            {[0, 1].map((i) => (
              <div key={i} className={styles.skeletonCard}>
                <span className={styles.skeletonLineWide} />
                <span className={styles.skeletonLineShort} />
              </div>
            ))}
          </div>
        )}

        {/* No Calls */}
        {!loading && !hasCalls && (
          <div className={styles.emptyCard}>
            <div className={styles.emptyIcon} aria-hidden="true">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <path
                  d="M4 13a8 8 0 0 1 16 0"
                  stroke="#6524EB"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
                <rect x="3" y="13" width="4" height="7" rx="2" stroke="#6524EB" strokeWidth="1.8" />
                <rect x="17" y="13" width="4" height="7" rx="2" stroke="#6524EB" strokeWidth="1.8" />
              </svg>
            </div>
            <h3 className={styles.emptyTitle}>No live calls right now</h3>
            <p className={styles.emptyText}>
              When a caller is talking to your AI receptionist, the call shows
              up here and you can listen in live.
            </p>
            <button
              type="button"
              className={styles.refreshBtn}
              onClick={fetchActiveCalls}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M20 11a8 8 0 1 0-2.34 5.66M20 4v7h-7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Refresh
            </button>
          </div>
        )}

        {/* Calls List */}
        {!loading && calls.map((call) => (
          <div
            key={call.call_id}
            className={styles.callCard}
            
            onClick={() => {
              sessionStorage.setItem('liveMonitoringFrom', 'active-calls');
              sessionStorage.setItem('activeCallsCount', calls.length.toString());
              navigate(`/live-monitoring/${call.call_id}`);
            }}
            >
            <div className={styles.callCardTop}>
              <div className={styles.callerInfo}>
                <div className={styles.liveDot} />
                <span className={styles.callerName}>
                  {call.call_type === 'web_call'
                    ? '🌐 Web Caller'
                    : `📞 ${call.from_number || 'Unknown'}`}
                </span>
              </div>
              <span className={styles.duration}>
                {formatDuration(call.start_timestamp)}
              </span>
            </div>

            <div className={styles.callCardBottom}>
              <span>{call.call_type === 'web_call' ? 'Web Call' : 'Phone Call'}</span>
              <span>•</span>
              <span>{call.direction || 'inbound'}</span>
              <span>•</span>
              <span className={styles.viewLive}>
                View Live →
              </span>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default ActiveCallsList;